import GrowerModel from '@/models/result/GrowerModel'
import ResultsServiceCollection from '@/collections/ResultsServiceCollection'

export default class GrowerCollection extends ResultsServiceCollection {
  model () {
    return GrowerModel
  }

  getModelsFromResponse (response) {
    const models = []
    const { data } = response.getData()

    if (data.pagination) {
      this.set('count', data.pagination.total)
    }

    if (data.growers) {
      data.growers.forEach((insert) => {
        const temp = (new (this.model())(insert))
        models.push(temp)
      })
    }

    return models
  }
}
